import { VFC } from 'react'
import { absoluteFill } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

export type RatingProps = RatingStyleProps & {
  char: string
  value: number
  onChange?: (target: number) => void
}
const RatingComponent: VFC<RatingProps> = ({
  max,
  char,
  onChange,
  value = 0,
  disabled,
  isCenter,
  ...styleProps
}) => (
  <RatingDiv value={value} max={max} {...styleProps} isCenter={isCenter}>
    {[...Array(max)].map((_, idx) => (
      <span key={idx}>{char}</span>
    ))}
    <input
      type="range"
      value={value}
      onChange={({ target: { value } }) => (onChange ? onChange(+value) : {})}
      disabled={disabled}
      max={max}
      min={0}
      step={1}
    />
  </RatingDiv>
)

export const Rating = styled(RatingComponent)``

type RatingStyleProps = {
  max: number
  activeColor: string
  inactiveColor: string
  isCenter: boolean
  disabled?: boolean
  className?: string
}
const RatingDiv = styled.div<RatingStyleProps & { value: number }>`
  position: relative;
  width: fit-content;
  font-size: 20px;
  ${({ value, max, activeColor, inactiveColor, isCenter }) => {
    const ratio = (value / max) * 100
    return css`
      background: linear-gradient(
        to right,
        ${activeColor} ${ratio}%,
        ${inactiveColor} ${ratio}%
      );
      ${isCenter && 'margin: 0 auto;'}
    `
  }}

  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  span {
    padding: 0 2px;
    user-select: none;
  }
  input {
    ${absoluteFill};
    // cursor: pointer;
    left: -20%;
    width: 120%;
    appearance: none;
    &::-webkit-slider-thumb {
      width: 0;
      height: 0;
      appearance: none;
    }
  }
`
